var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9983 15.0594C29.9983 6.77905 23.2829 0.0664062 14.9992 0.0664062C6.71542 0.0664062 0 6.77905 0 15.0594C0 22.0904 4.84293 27.9905 11.376 29.6109V19.6412H8.28313V15.0594H11.376V13.0851C11.376 7.98208 13.6864 5.6168 18.6985 5.6168C19.6489 5.6168 21.2886 5.80331 21.9594 5.98922V10.1423C21.6054 10.1051 20.9904 10.0865 20.2267 10.0865C17.7674 10.0865 16.8171 11.0179 16.8171 13.4389V15.0594H21.7164L20.8746 19.6412H16.8171V29.9426C24.244 29.046 29.9989 22.7249 29.9989 15.0594H29.9983Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/FB Logo.a82b746a0c0cf42ced900a77ecf2077b.svg";
export { ForwardRef as ReactComponent };